import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["groupCheckbox", "scopeField", "approveButton"]

  updateScopes() {
    const selectedScopes = [];
    this.groupCheckboxTargets.forEach((cb) => {
      if (cb.checked) {
        selectedScopes.push(...cb.dataset.scopes.split(" "));
      }
    });
    this.scopeFieldTarget.value = selectedScopes.join(" ");
    this.approveButtonTarget.disabled = selectedScopes.length === 0;
  }
}
